import React from 'react'
const Home = () => {
    return (
        <div className='text-primary rounded-md p-2 my-3 '>
      
            <h1 className='font-1 text-3xl drop-shadow-sm font-semibold'>Cool Programming Projects</h1>
            <p className='text-base font-2  '>Quality web solutions at unbeatable prices. Your digital success, our commitment.</p>
        </div>
    )
}

export default Home